import { CombinedUserData, PrivateClientFinancingProfile } from '@otw/models'
import { pandaApi } from './modules/pandaApi'
import { portalApi } from './modules/portalApi'
import { sharedApi } from './modules/sharedApi'

// TODO: Remove these, DO NOT DO THIS
export interface GetAllUsersResponse {
  users: CombinedUserData[]
  /** Present on the first page only; subsequent pages omit this to avoid redundant count queries. */
  total?: number
  page?: number
  limit?: number
  hasMore?: boolean
  lastDocId?: string | null
}

export interface ClientFinancingProfileResponse {
  id: string
  email: string
  first_name: string
  last_name: string
  company_name: string
  dealership_name: string
  financingProfile: PrivateClientFinancingProfile | null
  error?: string
}
interface ApiClient {
  panda: typeof pandaApi
  portal: typeof portalApi
  sharedFunctions: typeof sharedApi
}

export const apiClient: ApiClient = {
  panda: pandaApi,
  portal: portalApi,
  sharedFunctions: sharedApi,
}
